import { RouteBase } from "./route-base.model";

export class LtlRoute extends RouteBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected comment: string,
    public chargeableWeightPrice?: number,
  ) {
    super(id, discriminator, comment);
  }

  public getChargeableWeightPrice(): number {
    return this.chargeableWeightPrice;
  }
  public setChargeableWeightPrice(param: number) {
    this.chargeableWeightPrice = param;
  }
}
